import "../../style/components/NavPicRect.scss";
import { NavLink } from "react-router-dom";

export default function NavPicRect(props) {
  return (
    <NavLink to={props.to} className="nav-pic-rect">
      <div>
        <span dangerouslySetInnerHTML={{ __html: props.text }}></span>
      </div>
      <div className="free-pane"></div>
      <img
        src={`/asset/it-solution/${props.imgFilename}_720.webp`}
        alt={props.imgAlt}
        loading="lazy"
      ></img>
    </NavLink>
  );
}
